import { lazy, Suspense } from "react";
import Fallback from "../../custom/fallback/fallback";
import DashboardLayout from "../../screens/dashboardLayout/dashboardLayout";
const Main = lazy(() => import('../../components/Corporate/profile/main'))

const CorporateProfile = () => {
    return (
        <DashboardLayout>
            <Suspense fallback={<Fallback />}>
                <Main />
            </Suspense>
        </DashboardLayout>
    )
}

export default CorporateProfile;